import React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 8
  },
  "& .MuiDialogTitle-root": {
    margin: 0,
    padding: "16px 24px",
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: 1.25,
    fontFamily: "'Montserrat', sans-serif",
    borderBottom: "1px solid #ECEFF4"
  },
  "& .MuiDialogContent-root": {
    padding: "16px 24px"
  },
  "& .MuiDialogActions-root": {
    padding: "16px 24px"
  }
}));

interface modalProps {
  open: boolean;
  setOpen: (arg0: boolean) => void;
  children: any;
  fullWidth?: boolean;
}

const Modal: React.FC<modalProps> = ({
  open = false,
  setOpen = () => {},
  children = "",
  fullWidth = false
}) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={fullWidth}
      >
        {children}
      </BootstrapDialog>
    </div>
  );
};
export default Modal;
